import { LogicContext } from '../types';

export const setSearchPhrases = async (context: LogicContext) => {
  const { loggedIn } = context.user;
  const updates = [
    {
      type: 'setLayoutProperty',
      data: {
        path: `components.SearchHistory.properties.phrases`,
        value: context.recentPhrases,
      },
    },
  ];
  if (loggedIn) {
    updates.push({
      type: 'setLayoutProperty',
      data: {
        path: `components.SearchSuggestions.properties.recentPhrases`,
        value: context.recentPhrases,
      },
    });
  }

  return {
    updates,
  };
};
